import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

export default function Hero({ 
  title, 
  subtitle, 
  image, 
  primaryButton, 
  secondaryButton,
  height = 'h-[600px]',
  overlay = true 
}) {
  return (
    <div className={`relative ${height} flex items-center justify-center overflow-hidden`}>
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${image})` }}
      >
        {overlay && <div className="absolute inset-0 bg-primary/70"></div>}
      </div>
      
      <div className="relative z-10 container-custom text-center text-white px-4">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            {subtitle}
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {primaryButton && (
            <Link 
              to={primaryButton.link} 
              className="btn-primary inline-flex items-center justify-center space-x-2"
            >
              <span>{primaryButton.text}</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          )}
          {secondaryButton && (
            <Link 
              to={secondaryButton.link} 
              className="btn-outline bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-primary inline-flex items-center justify-center space-x-2"
            >
              <span>{secondaryButton.text}</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
